<script setup>
// Google Ads > Reklamlar
//
// Duyarli arama reklamlarinin adi yoktur; sunucu ilk basligi ad
// olarak dolduruyor ki listede bos satir gorunmesin.
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import GoogleAdsKabuk from './GoogleAdsKabuk.vue';
import GoogleAdsTablo from './GoogleAdsTablo.vue';
import { getir, hataMetni } from './kopru.js';

const { t } = useI18n();
const route = useRoute();

const satirlar = ref([]);
const paraBirimi = ref('');
const yukleniyor = ref(false);
const hata = ref('');

const SUTUNLAR = [
  { alan: 'ad', anahtar: 'GOOGLE_ADS.SUTUN.AD', siralanabilir: true, vurgu: true },
  { alan: 'durum', anahtar: 'GOOGLE_ADS.SUTUN.DURUM', tur: 'durum', siralanabilir: true },
  { alan: 'tur', anahtar: 'GOOGLE_ADS.SUTUN.TUR', tur: 'etiket', siralanabilir: true },
  { alan: 'reklam_grubu', anahtar: 'GOOGLE_ADS.SUTUN.REKLAM_GRUBU', siralanabilir: true },
  { alan: 'kampanya', anahtar: 'GOOGLE_ADS.SUTUN.KAMPANYA', siralanabilir: true },
  { alan: 'harcama', anahtar: 'GOOGLE_ADS.SUTUN.HARCAMA', tur: 'para', siralanabilir: true },
  { alan: 'gosterim', anahtar: 'GOOGLE_ADS.SUTUN.GOSTERIM', tur: 'sayi', siralanabilir: true },
  { alan: 'tiklama', anahtar: 'GOOGLE_ADS.SUTUN.TIKLAMA', tur: 'sayi', siralanabilir: true },
  { alan: 'donusum', anahtar: 'GOOGLE_ADS.SUTUN.DONUSUM', tur: 'sayi', siralanabilir: true },
];

const yukle = async aralik => {
  yukleniyor.value = true;
  hata.value = '';
  try {
    const veri = await getir(route.params.accountId, 'reklamlar', { aralik });
    satirlar.value = veri.reklamlar || [];
    paraBirimi.value = veri.para_birimi || '';
  } catch (e) {
    satirlar.value = [];
    hata.value = hataMetni(e, t('GOOGLE_ADS.HATA'));
  } finally {
    yukleniyor.value = false;
  }
};
</script>

<template>
  <GoogleAdsKabuk
    :baslik="t('GOOGLE_ADS.REKLAMLAR')"
    :aralik-goster="true"
    @aralik="yukle"
  >
    <div class="flex flex-col gap-3">
      <p v-if="hata" class="text-sm text-n-ruby-11">{{ hata }}</p>
      <div v-if="yukleniyor" class="flex justify-center p-10">
        <Spinner class="text-n-brand" />
      </div>
      <GoogleAdsTablo
        v-else
        :sutunlar="SUTUNLAR"
        :satirlar="satirlar"
        :para-birimi="paraBirimi"
        varsayilan-siralama="gosterim"
      />
    </div>
  </GoogleAdsKabuk>
</template>
